<footer class="app_footer__container">
  <p class="app_footer__textContainer">
    <span>© Copyright 2023</span>
    <span>
      <img src="../../../../assets/img/conexia-logo.svg" />
    </span>
    <span>| Todos los derechos reservados.</span>
  </p>
</footer>
